import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

const AuthCallback = () => {
  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Check for magic link parameters first
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const email = urlParams.get('email');
        
        if (token && email) {
          // Preserve returnUrl / next for callers that want to land back in the app.
          const rawReturnUrl = urlParams.get('returnUrl') || urlParams.get('next');
          let safeReturnUrl;
          if (rawReturnUrl) {
            try {
              const parsed = new URL(rawReturnUrl, window.location.origin);
              if (parsed.origin === window.location.origin) {
                safeReturnUrl = parsed.pathname + parsed.search + parsed.hash;
              }
            } catch (error) {
              console.warn('Invalid returnUrl ignored:', rawReturnUrl, error);
            }
          }
          const verifyPath = `/auth/verify?token=${token}&email=${encodeURIComponent(email)}${safeReturnUrl ? `&returnUrl=${encodeURIComponent(safeReturnUrl)}` : ''}`;
          window.history.pushState({}, '', verifyPath);
          window.dispatchEvent(new PopStateEvent('popstate'));
          return;
        }
        
        // Handle Supabase OAuth callback
        if (supabase) {
          const { data, error } = await supabase.auth.getSession();
          
          if (data.session) {
            // SECURITY: exact whitelist only — never derive admin from email substring
            const adminEmails = ['admin@testingvala.com', 'owner@testingvala.com'];
            const role = adminEmails.includes(data.session.user.email?.toLowerCase()) ? 'admin' : 'user';
            const authSession = {
              email: data.session.user.email,
              verified: true,
              deviceId: localStorage.getItem('device_id') || 'oauth-device',
              loginTime: Date.now(),
              expiresAt: Date.now() + (30 * 24 * 60 * 60 * 1000),
              role,
              token: data.session.access_token,
            };
            
            localStorage.setItem('auth_session', JSON.stringify(authSession));
            localStorage.setItem('dev_auth_user', JSON.stringify(data.session.user));
            
            toast.success('Successfully signed in!');
            window.location.href = '/';
          } else {
            toast.error('Authentication failed');
            window.location.href = '/';
          }
        } else {
          // No Supabase - redirect to home
          toast.error('Authentication service unavailable');
          window.location.href = '/';
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Authentication failed');
        window.location.href = '/';
      }
    };

    handleAuthCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;